import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/global.css';
import 'cesium/Build/Cesium/Widgets/widgets.css';
// E0：编辑器命令总线（生产注册 + 开发调试桥 __commandBus/__commandBusStores）
import './core/commandBus';

import * as Cesium from 'cesium';
(window as any).Cesium = Cesium;

// G2：区域框选 e2e 调试桥
import { projectModelBoxClient, projectPointClient, cameraRight, g2Info } from './utils/g2Debug';
(window as any).__g2 = { projectModelBoxClient, projectPointClient, cameraRight, g2Info };

// H2：平台品牌（白标 OEM）启动注入（异步，不阻塞渲染）
import { initBrand } from './stores/brandStore';
void initBrand();

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
